// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"215":"9ad7385e","275":"55a1fdb8","308":"04a1452e","612":"ba858e34","616":"63bed721","663":"76b15cc2","729":"04a1452e","954":"04a1452e","987":"04a1452e"}[chunkId] + ".chunk.css";
};